import { PageMeta } from "src/components";
import { appConfig } from "src/config";
import { useTranslate } from "src/i18n";
import { KnowledgeBaseWidget, KnowledgeBaseWidgetLk } from "src/widgets";

import { routePath, RoutePathKeys } from "./constants";

export const KnowledgeBasePage = ({ route }: { route: RoutePathKeys }) => {
  const { t } = useTranslate();

  const title = t("knowledge_base.meta.title", "База знаний — {displayName}", {
    displayName: appConfig.displayName,
  });
  const description = t(
    "knowledge_base.meta.description",
    "Документация, инструкции и ответы на частые вопросы по работе с {displayName}.",
    { displayName: appConfig.displayName },
  );

  return (
    <>
      {route === "base" && (
        <PageMeta
          title={title}
          description={description}
          path="/knowledge-base"
        />
      )}
      {route === "lk" ? (
        <KnowledgeBaseWidgetLk basePath={routePath[route]} route={route} />
      ) : (
        <KnowledgeBaseWidget basePath={routePath[route]} route={route} />
      )}
    </>
  );
};
